import Helper from './Helper';
import '../assets/scss/side-by-side.scss';

class SideBySide {
    /**
     * Initialize the side by side switcher
     */
    constructor() {
        // Load required assets
        import("../assets/scss/side-by-side.scss");
    }

    /**
     * Load the flag
     * 
     * @return {HTMLDivElement}
     */
    load(linguise_switcher)
    {
        // Sort languages
        Helper.sort(linguise_switcher);

        const language_settings = linguise_switcher.language_settings;
        const languages_lists = Helper.getOrderedLanguageList(
            linguise_switcher.available_languages, linguise_switcher.default_language, language_settings?.language_flag_order,
        );

        const side_by_side_elem = document.createElement('div');
        side_by_side_elem.innerHTML = `
            <div class="linguise_switcher side_by_side_lang_list ${language_settings?.flag_shape === 'rectangular' ? 'linguise_flag_rectangular' : 'linguise_flag_rounded'}">
                ${languages_lists.map(language => {
                    return `<a href="${Helper.getLanguageUrl(linguise_switcher, language.code)}">
                                ${Helper.renderFlag(language_settings, language.code)}
                                ${Helper.renderLanguageName(language_settings, language.code, language.name, language.original_name)}
                            </a>`
                }).join('')}
            </div>`
        side_by_side_elem.id = 'side_by_side';

        // Replace Linguise shortcode ([linguise]) to switcher
        Helper.replaceLinguiseShortcodeToSwitcher(language_settings?.position, side_by_side_elem, linguise_switcher);

        return side_by_side_elem;
    }

    postLoad() {/* stub */}
}

export default SideBySide;
